import React, { useEffect, useState } from "react";
import { IntegrationsApi } from "../api/integrationsApi";
import IntegrationList from "../components/integrations/IntegrationList";
import IntegrationCard from "../components/integrations/IntegrationCard";
import IntegrationExtras from "../components/integrations/IntegrationExtras";
import IntegrationCreateModal from "../components/integrations/IntegrationCreateModal";

import "../styles/integrations/integrations.css";

export default function IntegrationsPage() {
  const [integrations, setIntegrations] = useState<any[]>([]);
  const [active, setActive] = useState<string | null>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [integration, setIntegration] = useState<any>(null);
  const [mobileView, setMobileView] = useState<"list" | "detail" | "addField">("list");

  const isMobile = () => window.innerWidth <= 768;

  const loadList = async () => {
    const res = await IntegrationsApi.getAll();
    setIntegrations(res.data);
  };

  const loadOne = async (name: string) => {
    const res = await IntegrationsApi.getOne(name);
    setIntegration({
      ...res.data,
      config: res.data.config ?? {},
      fieldTypes: res.data.fieldTypes ?? {},
    });
  };

  useEffect(() => { loadList(); }, []);
  useEffect(() => { if (active) loadOne(active); }, [active]);

  function handleSelect(name: string) {
    setActive(name);
    if (isMobile()) setMobileView("detail");
  }

  const saveIntegration = async () => {
    if (!active || !integration) return;
    await IntegrationsApi.update(active, {
      enabled: integration.enabled,
      displayName: integration.displayName,
      config: integration.config,
      fieldTypes: integration.fieldTypes,
    });
    await loadList();
    await loadOne(active);
  };

  const deleteIntegration = async () => {
    if (!active) return;
    await IntegrationsApi.delete(active);
    setActive(null);
    setIntegration(null);
    setMobileView("list");
    await loadList();
  };

  /* ── МОБИЛЬНЫЙ LAYOUT ── */
  if (isMobile()) {
    /* Список */
    if (mobileView === "list") {
      return (
        <div style={{ display: "flex", flexDirection: "column", padding: 12, gap: 10 }}>
          <select
            className="mob-integration-select"
            value={active ?? ""}
            onChange={(e) => { if (e.target.value) handleSelect(e.target.value); }}
            style={{
              width: "100%", background: "#1a1f2e", border: "1px solid #2d3448",
              borderRadius: 10, color: "#f9fafb", fontSize: 14, padding: "10px 12px", outline: "none",
            }}
          >
            <option value="">Выберите интеграцию...</option>
            {integrations.map((i: any) => (
              <option key={i.name} value={i.name}>{i.displayName || i.name}</option>
            ))}
          </select>

          <button
            onClick={() => setShowCreateModal(true)}
            style={{
              width: "100%", background: "#6366f1", border: "none", borderRadius: 10,
              color: "#fff", fontSize: 14, fontWeight: 600, padding: "12px 0", cursor: "pointer",
            }}
          >
            + Новая интеграция
          </button>

          {showCreateModal && (
            <IntegrationCreateModal
              onClose={() => setShowCreateModal(false)}
              onCreated={() => { setShowCreateModal(false); loadList(); }}
            />
          )}
        </div>
      );
    }

    /* Форма интеграции */
    if (mobileView === "detail") {
      return (
        <div style={{ display: "flex", flexDirection: "column", padding: 12, gap: 12 }}>
          <button
            onClick={() => setMobileView("list")}
            style={{ display: "flex", alignItems: "center", gap: 6, background: "none", border: "none", color: "#818cf8", fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 0 }}
          >
            ← Назад
          </button>

          {integration && (
            <>
              <IntegrationCard
                data={integration}
                setData={setIntegration}
                onSave={saveIntegration}
                onDelete={deleteIntegration}
              />

              <button
                onClick={() => setMobileView("addField")}
                style={{
                  width: "100%", background: "#1a1f2e", border: "1px solid #2d3448",
                  borderRadius: 10, color: "#818cf8", fontSize: 14, fontWeight: 600,
                  padding: "12px 0", cursor: "pointer",
                }}
              >
                + Новое поле
              </button>

              {/* WA test send если whatsapp */}
              <IntegrationExtras
                data={integration}
                setData={setIntegration}
                onSave={saveIntegration}
                mobileFieldsOnly
              />
            </>
          )}
        </div>
      );
    }

    /* Добавление поля */
    if (mobileView === "addField") {
      return (
        <div style={{ display: "flex", flexDirection: "column", padding: 12, gap: 12 }}>
          <button
            onClick={() => setMobileView("detail")}
            style={{ display: "flex", alignItems: "center", gap: 6, background: "none", border: "none", color: "#818cf8", fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 0 }}
          >
            ← К интеграции
          </button>
          {integration && (
            <IntegrationExtras
              data={integration}
              setData={setIntegration}
              onSave={saveIntegration}
            />
          )}
        </div>
      );
    }
  }

  /* ── ДЕСКТОП LAYOUT ── */
  return (
    <div className="integrations-layout integration-shell">
      <div className="col-left integration-list-wrap">
        <button className="add-btn" onClick={() => setShowCreateModal(true)}>
          + Новая интеграция
        </button>
        <IntegrationList
          items={integrations}
          active={active}
          onSelect={(name: string) => setActive(name)}
        />
      </div>

      <div className="col-center">
        {integration ? (
          <IntegrationCard
            data={integration}
            setData={setIntegration}
            onSave={saveIntegration}
            onDelete={deleteIntegration}
          />
        ) : (
          <div className="empty">Выберите интеграцию</div>
        )}
      </div>

      <div className="col-right">
        {integration && (
          <IntegrationExtras
            data={integration}
            setData={setIntegration}
            onSave={saveIntegration}
          />
        )}
      </div>

      {showCreateModal && (
        <IntegrationCreateModal
          onClose={() => setShowCreateModal(false)}
          onCreated={() => { setShowCreateModal(false); loadList(); }}
        />
      )}
    </div>
  );
}
